<template>
  <v-container fluid>
    <h2 v-if="!hideTitle" class="text-subtitle-1 font-weight-medium text-capitalize mb-2">{{ $t('logRecord') }}</h2>
    <Datatable
      :isLoading="loading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="filter.page"
      :pageLimit.sync="filter.limit"
      :itemTotal="total"
      :pageLimitOptions="[5, 10, 20, 50]"
      @options-update="_onOptionUpdate()"
    >
      <template v-slot:[`item.action_type`]="{ item }">
        <span class="text-capitalize">{{ _parseAction(item.action_type) }}</span>
      </template>
    </Datatable>
  </v-container>
</template>

<script>
import Datatable from './Datatable.vue'
export default {
  name: 'LogTable',
  components: {
    Datatable,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
      required: true,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    filter: {
      page: 1,
      limit: 5,
    },

    tableHeaders: [
      { value: 'create_date', text: vm.$t('createdTime'), width: 130 },
      { value: 'action_type', text: vm.$t('actionType'), width: 130 },
      { value: 'action_detail', text: vm.$t('actionDetails') },
      { value: 'account_username', text: vm.$t('actionAccount'), align: 'end' },
    ],
  }),
  methods: {
    getFilter() {
      return this.filter
    },
    _onOptionUpdate() {
      this.$emit('options-update', this.filter)
    },
    _parseAction(action) {
      const s = `actionTypeOptions.${action}`
      const t = this.$t(s)
      if (t === s) return action
      return t
    },
  },
}
</script>
